import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Document } from '@/model/document2/document';
import { Page } from '@/model/document2/page/page';

// ページの削除コマンド
export class DeletePageCommand implements ICommandBase
{
    private index! : number;
    private document! : Document;
    private doneCallback! : () => void;

    private orgPage : Page | null = null;

    constructor(index : number, document : Document, doneCallback : () => void)
    {
        this.index = index;
        this.document = document;
        this.doneCallback = doneCallback;

        this.orgPage = this.document.pageList[index];
    }

    public do() : void
    {
        // 最終ページがカレントの場合は、カレントが消滅するので一つ前に移動
        if(this.document.currentPageIndex >= this.document.pageList.length - 1)
        {
            this.document.currentPageIndex = this.document.pageList.length - 2;
        }
        // ページを削除
        this.document.removePage(this.index);
        
        this.doneCallback();
    }

    public undo() : void
    {
        if(this.orgPage != null)
        {
            // 保持していたページを復帰
            this.document.insertPage(this.index, this.orgPage);
        }

        this.doneCallback();
    }

    public redo() : void
    {
        // 最終ページがカレントの場合は、カレントが消滅するので一つ前に移動
        if(this.document.currentPageIndex >= this.document.pageList.length - 1)
        {
            this.document.currentPageIndex = this.document.pageList.length - 2;
        }
        // ページを削除
        this.document.removePage(this.index);
        
        this.doneCallback();
    }
}